import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { SCREEN } from '../../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../../common/selectCurrencyUnit/useFormatCurrency'
import TableSectorPerformance from '../../common/table'
import {
  selectCellData,
  selectCompareVal,
  selectDataTable,
  selectLoading,
  selectRowGroup,
} from '../../store/slice'

const TableSize = ({ isDynamicReport, settingDynamic = {}, year = '' }) => {
  const compareValStore = useSelector(selectCompareVal)
  const { compareBetweenRatio: compareValDyn, sizeChecked = [] } =
    settingDynamic
  const compareVal = isDynamicReport ? compareValDyn : compareValStore

  const data = useSelector(selectDataTable(compareVal, 'size'))
  const isLoading = useSelector(selectLoading)
  const titleYear = I18n.t('companyAnalysis.industryAnalysis.FY', {
    year: year,
  })
  const { formatCurrency, formatedUnit } = useFormatCurrency(
    SCREEN.INDUSTRY_ANALYSIS,
  )

  const headers = useMemo(() => {
    const result = [
      {
        title: titleYear,
        colId: 'typeGroup',
        thStyle: {
          justifyContent: 'flex-start',
        },
      },
      {
        title: '',
        colId: 'vsicId',
      },
      sizeChecked.includes('isTotalAssets') || !isDynamicReport
        ? {
            colId: 'totalAssets',
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (value) => formatCurrency({ value, year }),
            renderTh: () => (
              <Translate
                value="companyAnalysis.industryAnalysis.TOTAL_ASSETS_1"
                currencyUnit={formatedUnit}
              />
            ),
          }
        : undefined,
      sizeChecked.includes('isTotalRevenue') || !isDynamicReport
        ? {
            colId: 'totalRevenue',
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (value) => formatCurrency({ value, year }),
            renderTh: () => (
              <Translate
                value="companyAnalysis.industryAnalysis.TOTAL_REVENUE_1"
                currencyUnit={formatedUnit}
              />
            ),
          }
        : undefined,
      sizeChecked.includes('isTotalDebt') || !isDynamicReport
        ? {
            colId: 'totalDebt',
            isI18n: true,
            thStyle: {
              justifyContent: 'flex-end',
            },
            format: (value) => formatCurrency({ value, year }),
            renderTh: () => (
              <Translate
                value="companyAnalysis.industryAnalysis.TOTAL_DEBT_1"
                currencyUnit={formatedUnit}
              />
            ),
          }
        : undefined,
    ]
    return result.filter((item) => !!item)
  }, [sizeChecked, isDynamicReport])

  return (
    <div style={{ height: isDynamicReport ? 300 : 160 }}>
      <TableSectorPerformance
        dataTable={{
          typeComponent: 'size',
          data,
          headers,
          selectDataTable,
          selectCellData,
          selectRowGroup,
          isLoading,
          compareVal,
        }}
        isDynamicReport={isDynamicReport}
      />
    </div>
  )
}

export default TableSize
